import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { ToggleBlockAbstact } from '../common/toggle-block.abstract';
import { BasketKlarnaContentBlockComponent } from './basket-klarna-content-block.component';

@Component({
    selector: 'basket-klarna-tray',
    templateUrl: './basket-klarna-tray.html',
    standalone: true,
    imports: [BasketKlarnaContentBlockComponent, CommonModule, OffClickDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketKlarnaTrayComponent extends ToggleBlockAbstact {
    protected name: string = 'basketklarnatray';
}
